import { Button } from "react-admin";
import Typography from "@mui/material/Typography";
import { Row } from "../../misc/Row";
import type { CreateDrivingLessonFormValues } from "./CreateDrivingLessonForm";
import { useFormContext } from "react-hook-form";
import { useDialog } from "../../hooks/useDialog";
import { DrivingLessonRepetitionsDialog } from "../DrivingLessonRepetitionsDialog/DrivingLessonRepetitionsDialog";
import { Column } from "../../misc/Column";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useRef } from "react";

export function DrivingLessonRepetitionsField(props: { openOnMount?: boolean }) {
  const { openOnMount } = props;
  const { dialogProps, openDialog } = useDialog();
  const { watch } = useFormContext<CreateDrivingLessonFormValues>();
  const { student, dateTime, repetitions } = watch();
  const hasRepetitions = repetitions.length > 0;
  const hasOpenedOnMount = useRef(false);

  useEffect(() => {
    if (openOnMount && dateTime && !hasOpenedOnMount.current) {
      hasOpenedOnMount.current = true;
      openDialog();
    }
  }, [dateTime, openDialog, openOnMount]);

  if (!student) return null;
  return (
    <Row
      sx={{
        alignItems: "flex-start",
        justifyContent: "space-between",
        backgroundColor: "action.hover",
        borderRadius: "8px",
        p: 1,
      }}
    >
      <Column sx={{ px: 0.5 }}>
        <Typography variant="button" fontWeight={600}>
          Terminserie:
        </Typography>
        <Typography variant="body2" sx={{ color: hasRepetitions ? "text.primary" : "text.secondary" }}>
          {hasRepetitions ? `${repetitions.length + 1} Termine insgesamt` : "Keine Terminserie"}
        </Typography>
      </Column>
      <Button
        variant="outlined"
        sx={{ height: "40px" }}
        startIcon={hasRepetitions ? <EditIcon /> : <AddIcon />}
        label={hasRepetitions ? "Bearbeiten" : "Terminserie erstellen"}
        disabled={!dateTime}
        onClick={openDialog}
      />
      <DrivingLessonRepetitionsDialog {...dialogProps} />
    </Row>
  );
}
